import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var seoTextSchema = {
    bg_description: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'SEO Текст на български',
        value: '',
        validation: {
            required: false,
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въвдете текст на български',
    }),
    en_description: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'textarea',
        label: 'SEO Текст на английски',
        value: '',
        validation: {
            required: false,
        },
        valid: true,
        touched: true,
        errorMsg: 'Моля, въвдете тест на английски',
    }),
};
export default seoTextSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/seoTextSchema.ts
// module id = 463
// module chunks = 0